import axiosInstance from './axiosConfig';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FoodConfigService = {
  getFoodConfig: async () => {
    const response = await axiosInstance.get(`${API_BASE_URL}/food-config`);
    return response.data;
  },

  getRestaurantFoodConfig: async (restaurantUuid) => {
    const response = await axiosInstance.get(`${API_BASE_URL}/restaurants/${restaurantUuid}/food-config`);
    return response.data;
  },

  getScopedFoodConfig: async ({ restaurantUuid }) => {
    if (restaurantUuid && restaurantUuid !== 'all') {
      return FoodConfigService.getRestaurantFoodConfig(restaurantUuid);
    }

    return FoodConfigService.getFoodConfig();
  },

  createFoodConfig: async (foodConfig) => {
    const response = await axiosInstance.post(`${API_BASE_URL}/food-config`, foodConfig);
    return response.data;
  },
};
